enum CSQueryableEventType {
    IDENTIFY = 'IDENTIFY',
    SESSION = 'SESSION',
    VISIT = 'VISIT',

    CLICK = 'CLICK',
    PAGE = 'PAGE',
    TRACK = 'TRACK',
}

export { CSQueryableEventType };
